module.exports = __webpack_public_path__ + "static/img/ISO45001_EN.c60ec95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISO45001_EN.png
// module id = E3P7
// module chunks = 1